<template>
  <div>
        <div style="display: flex; flex-direction: column;">
            <div v-if="!hideSaveOption" style="width: 100%; text-align: left; margin-bottom: 20px;">
                <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                    <el-checkbox v-model="enable_search_save">
                        Save This Search For Future
                    </el-checkbox>
                
                    <el-input v-if="enable_search_save" @focus="$event.target.select()"
                        size="small"
                        placeholder="Search Title"
                        v-model="search_name"
                        style="width: 250px; margin-left: 20px;">
                    </el-input>
                </div>
            </div>
            <span style="">

            </span>
            <div v-if="!hideSaveOption" style="wdith: 100%; text-align: left; dispaly: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                
                <el-tag
                    v-for="tag in $store.getters.getMasterQueryList"
                    :key="tag.id"
                    style="margin-right: 10px; cursor: pointer;"
                    closable
                    @click="applyPreSearch(tag)"
                    @close="deleteSearchTag(tag)">
                    {{tag.query_name}}
                </el-tag>
                
                <br><br>

            </div>
            <div 
            v-for="(data, index) in getSearchTermArray"
            :key="index"
            style="margin-top: 10px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
                
                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; width: 90%;">
                    <el-select 
                        @change="changeFocus('search_term_'+index)"
                        size="small"
                        filterable
                        v-model="data.column_name"
                        placeholder="Column Name" style="width: 30%;">
                        <el-option
                            v-for="(item, itemIndex) in getSearchKeys"
                            :key="itemIndex+'_0'"
                            :label="item.label"
                            :value="item.value">
                            <span style="float: left" v-html="item.label"></span>
                        </el-option>
                    </el-select>
                    <div v-if="getSearchKeys.findIndex(t => t.value == data.column_name && t.store_list)>=0" style="width: 60%;">
                        <el-select 
                            size="small"
                            v-model="data.search_term"
                            placeholder="Select..." style="width: 95%;">
                            <el-option
                                v-for="(item, itemIndex) in $store.getters.getAccessibleStoreList"
                                :key="itemIndex"
                                :label="item.store_name"
                                :value="getSearchKeys.filter(t => t.value == data.column_name && t.store_list && t.id_store).length>0 ? item.id : item.store_name">
                                <span style="float: left" v-html="item.store_name"></span>
                            </el-option>
                        </el-select>
                        
                    </div>
                    <div v-else-if="getSearchKeys.findIndex(t => t.value == data.column_name && t.date_range_field)>=0" style="width: 60%;">
                        <el-date-picker
                            v-model="data.search_term_date_array"
                            type="daterange"
                            align="right"
                            size="small"
                            unlink-panels
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            value-format="yyyy-MM-dd"
                            format="MMM dd yyyy"
                            style="width: 100%;">
                        </el-date-picker>                        
                    </div>
                    <div v-else-if="getSearchKeys.findIndex(t => t.value == data.column_name && t.date_field)>=0" style="width: 60%;">
                        
                        <el-date-picker
                            size="small"
                            type="date"
                            v-model="data.search_term"
                            style="width: 95%;"
                            value-format="yyyy-MM-dd"
                            format="MMM dd yyyy">
                        </el-date-picker>
                        
                    </div>
                    <div v-else-if="getSearchKeys.findIndex(t => t.value == data.column_name && t.drop_down_values)>=0" style="width: 60%;">
                        <el-select 
                            size="small"
                            filterable
                            v-model="data.search_term"
                            placeholder="Select..." style="width: 95%;">
                            <el-option
                                v-for="item in getSearchKeys[getSearchKeys.findIndex(t => t.value == data.column_name)].drop_down_values"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                <span style="float: left" v-html="item.label"></span>
                            </el-option>
                        </el-select>
                        
                    </div>
                    <el-input @focus="$event.target.select()"
                        v-else
                        :id="'search_term_'+index"
                        placeholder="Search term..."
                        size="small"
                        clearable
                        style="width: 60%; text-align: left; margin-left: 20px;"
                        v-model="data.search_term">
                    </el-input>
                </div>

                <div style="top: 5px; position: relative; margin-left: 20px; width: 10%; text-align: right;">
                    <el-tooltip class="item" effect="dark" content="Add">
                        <a title="Add" @click="addNewTerm" style="cursor: pointer; font-size: 16px;">
                        <i class="el-icon-circle-plus"></i>
                        </a>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="Delete">
                        <a :disabled="index === 0" @click="removeTerm(index)" style="cursor: pointer; margin-left: 10px; color: red; font-size: 16px;">
                            <i class="el-icon-delete"></i>
                        </a>
                    </el-tooltip>
                </div>
            </div>

            <div style="width: 100%; text-align: center; margin-top: 50px;">
                <el-button @click="searchNow" type="primary" size="small">Search Now</el-button>
                <el-button @click="$emit('loadAdvanceSearch', {search_term_array: []})" type="danger" size="small">Clear</el-button>
            </div>
      </div>
  </div>
</template>

<script>
const searchTermKey = {
    key: 0,
    column_name: '',
    search_term: '',
    search_term_date: '',
    search_term_date_array: ''
}

export default {
    props: ['searchKeys', 'hideSaveOption'],
    data() {
        return {
            search_term_array: [JSON.parse(JSON.stringify(searchTermKey))],
            enable_search_save: false,
            search_name: ''
        }
    },
    computed: {
        getSearchTermArray() {
            return this.search_term_array
        },
        getSearchKeys() {
            return this.searchKeys
        }
    },
    methods: {
        addNewTerm() {
            this.search_term_array.push(JSON.parse(JSON.stringify(searchTermKey)))
            this.resetArray()
        },
        removeTerm(index) {
            if(index === 0) {
                return
            }
            this.search_term_array.splice(index, 1)
            this.resetArray()
        },
        resetArray() {
            let key = 0
            this.getSearchTermArray.forEach(element => {
                element.key = key
                key = key + 1
            })
        },
        async searchNow() {
            if(this.enable_search_save) {
                await this.$store.dispatch('saveMasterSearchQuery',
                {
                    page_id: this.$store.getters.getAccessRights.id,
                    query_name: this.search_name, 
                    query_array: JSON.stringify(this.getSearchTermArray)
                })
                
                setTimeout(() => {
                    this.$emit('loadAdvanceSearch', {search_term_array: this.getSearchTermArray})    
                }, 1000);
                
            } else {
                this.$emit('loadAdvanceSearch', {search_term_array: this.getSearchTermArray})    
            }
            
        },
        async applyPreSearch(data) {
            this.enable_search_save = false
            this.search_term_array = data.query_array
            await this.searchNow()
        },
        deleteSearchTag(data) {
            /*this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                
            }).catch(() => {
                    
            });*/
            this.$store.dispatch('deleteMasterSearchQuery', {id: data.id, page_id: this.$store.getters.getAccessRights.id})
        }
    },
    mounted() {
        this.$store.dispatch('fetchMasterSearchQuery', {page_id: this.$store.getters.getAccessRights.id})
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/SearchField/Advanced.vue